import type { WorkflowContext } from './types';

const isValidParam = (value: unknown): value is string =>
  typeof value === 'string' && value !== 'undefined' && value.trim().length > 0;

export const workflowGuards = {
  isAuthenticated: ({ context }: { context: WorkflowContext }) => {
    return context.authStatus === 'authenticated';
  },
  isOrderlessAuthenticated: ({ context }: { context: WorkflowContext }) => {
    return context.retailerSettings?.features?.isOrderless === true;
  },
  isRehydrateFromServer: ({ context }: { context: WorkflowContext }) =>
    Boolean(context.requestId && context.orderNumber && context.token),
  hasConfig: ({ context }: { context: WorkflowContext }) => {
    return context.config !== null;
  },
  hasOrder: ({ context }: { context: WorkflowContext }) => {
    return context.order !== null;
  },
  hasOrderNumber: ({ context }: { context: WorkflowContext }) => {
    return context.orderNumber !== null;
  },
  canRedirectToClaimDetails: ({ context }: { context: WorkflowContext }) =>
    Boolean(
      isValidParam(context.requestId) &&
      isValidParam(context.orderNumber) &&
      isValidParam(context.retailer),
    ),
};
